import {v4 as uuidv4} from 'uuid';
const gender = {
  nam: 1,
  nu: 0,
};

const security = {
  checkEmulator: true,
  checkRoot: true,
};

export const appVarsRef = {
  deviceId: uuidv4(),
};

export {gender, security};
